// cmsCache.js
// Recuerda en el navegador las URLs de las imágenes del CMS para que, al volver a abrir
// una página, se muestre de inmediato la imagen correcta en vez de una de respaldo que
// luego cambia. Valores guardados:
//   - string → URL de la imagen del CMS
//   - null   → se consultó y no hay imagen en el CMS (usar la de respaldo)
// Una clave que no está guardada devuelve `undefined` (todavía no se sabe).

// v2: las URLs ahora llevan ?v=<fecha de subida>; se descartan las guardadas con el formato anterior.
const STORAGE_KEY = 'achipo_cms_images_v2';
const STORAGE_KEY_ANTIGUA = 'achipo_cms_images_v1';
try { window.localStorage.removeItem(STORAGE_KEY_ANTIGUA); } catch { /* sin almacenamiento */ }

const leer = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    return data && typeof data === 'object' ? data : {};
  } catch {
    return {};
  }
};

/** Devuelve la URL guardada (string), null si se sabe que no hay, o undefined si no se sabe. */
export const getCachedImage = (key) => {
  const data = leer();
  return Object.prototype.hasOwnProperty.call(data, key) ? data[key] : undefined;
};

/**
 * Primera URL disponible entre varias claves (ej. portada propia y luego la de Récords).
 * undefined si alguna clave aún no se conoce y ninguna tiene URL; null si se sabe que ninguna tiene.
 */
export const getFirstCachedImage = (keys) => {
  let desconocida = false;
  for (const key of keys) {
    const v = getCachedImage(key);
    if (v) return v;
    if (v === undefined) desconocida = true;
  }
  return desconocida ? undefined : null;
};

/** Guarda varias claves a la vez: { hero_bg: 'https://…', carousel_2: null } */
export const saveCachedImages = (entries) => {
  try {
    const data = { ...leer() };
    Object.entries(entries || {}).forEach(([k, v]) => {
      if (v === undefined) return;
      // Se guarda la URL tal cual (incluye ?v=<fecha de subida>, que cambia solo si la imagen cambia).
      // Se quita el ?t=… que agrega el CMS al subir, porque cambia en cada subida.
      data[k] = typeof v === 'string' ? v.replace(/[?&]t=\d+$/, '') : null;
    });
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* almacenamiento no disponible: se ignora */
  }
};
